<template>
    <img
        v-if="'CA' === country"
        src="../assets/flags/4x3/ca.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'ZA' === country"
        src="../assets/flags/4x3/za.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'RU' === country"
        src="../assets/flags/4x3/ru.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'BW' === country"
        src="../assets/flags/4x3/bw.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'IN' === country"
        src="../assets/flags/4x3/in.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'SL' === country"
        src="../assets/flags/4x3/sl.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'NA' === country"
        src="../assets/flags/4x3/na.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'LS' === country"
        src="../assets/flags/4x3/ls.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'BE' === country"
        src="../assets/flags/4x3/be.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'BR' === country"
        src="../assets/flags/4x3/br.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'LK' === country"
        src="../assets/flags/4x3/lk.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'MG' === country"
        src="../assets/flags/4x3/mg.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'NG' === country"
        src="../assets/flags/4x3/ng.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'IL' === country"
        src="../assets/flags/4x3/il.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'MY' === country"
        src="../assets/flags/4x3/my.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'AM' === country"
        src="../assets/flags/4x3/am.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'GL' === country"
        src="../assets/flags/4x3/gl.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'TZ' === country"
        src="../assets/flags/4x3/tz.svg"
        :alt="`Flag of ${country}`"
    />

    <img
        v-else-if="'TH' === country"
        src="../assets/flags/4x3/th.svg"
        :alt="`Flag of ${country}`"
    />
</template>

<script lang="ts" setup>
import { type SupportedFlag } from '@/components/flag'

defineProps<{
    country: SupportedFlag
}>()
</script>
